(() => {
  const KEY = 'azurialWishlistHandles';
  const read = () => { try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch { return []; } };
  const write = list => localStorage.setItem(KEY, JSON.stringify([...new Set(list)]));
  const paint = root => {
    const list = read();
    (root || document).querySelectorAll('[data-az-wish]').forEach(button => {
      const active = list.includes(button.dataset.azWish);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
      button.textContent = active ? '♥' : '♡';
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-az-wish]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const list = read(); const handle = button.dataset.azWish; const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1); else list.push(handle);
    write(list); paint(document);
    document.dispatchEvent(new CustomEvent('azurial:wishlist-change', { detail: { handles: list } }));
  });
  const page = document.querySelector('[data-az-wishlist-page]');
  const renderPage = () => {
    if (!page) return;
    const list = read(); let visible = 0;
    page.querySelectorAll('[data-wishlist-product]').forEach(item => {
      const show = list.includes(item.dataset.wishlistProduct);
      item.hidden = !show; if (show) visible++;
    });
    const count = page.querySelector('[data-az-wishlist-count]');
    if (count) count.textContent = `${visible} pièce${visible === 1 ? '' : 's'}`;
    const empty = page.querySelector('[data-az-wishlist-empty]');
    if (empty) empty.hidden = visible !== 0;
    paint(page);
  };
  document.addEventListener('azurial:wishlist-change', renderPage);
  paint(document); renderPage();
})();